import { FunctionComponent } from 'react';
import { FormProvider } from 'react-hook-form';

import { CredentialsForm } from '../../components/credentials-form';
import { useResetPasswordResult } from './providers/reset-password.provider';

export const ResetPasswordForm: FunctionComponent = () => {
  const { methods, handleSubmit } = useResetPasswordResult();

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <CredentialsForm
          usernameLabel={'Username'}
          buttonText={'Reset password'}
        />
      </form>
    </FormProvider>
  );
};
